import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GitBranchFilterComponent } from './git-branch-filter.component';

@NgModule({
  imports: [CommonModule, MatInputModule, MatButtonModule, ReactiveFormsModule, FontAwesomeModule],
  declarations: [GitBranchFilterComponent],
  exports: [GitBranchFilterComponent],
})
export class GitBranchFilterModule {}
